import gsap from 'gsap';
import type { ScrollCarouselRefs } from './scroll-carousel.types';
import bowser from 'bowser';
import { isDesktop } from '../../../hooks/useIsDesktopDevice';

export function setupScrollCarousel(
  timeline: gsap.core.Timeline,
  { carouselRef, marginsRef, carouselItemsRef, imagesRef, imageScale = 1.15 }: ScrollCarouselRefs,
): void {
  // Version 15.1 has a weird text-flickering issue when using 'x' instead of 'left'
  const setCarouselX = gsap.quickSetter(
    carouselRef.current,
    isDesktop && bowser.safari && parseFloat(`${bowser.version}`) < 15.2 ? 'left' : 'x',
    'px',
  );
  const setImageX: Array<(_value: number) => void> = [];

  imagesRef.current?.forEach((item) => {
    setImageX.push(gsap.quickSetter(item, 'x', '%') as (value: number) => void);
  });

  if (carouselRef?.current) {
    let marginWidth = 0;
    const { scrollWidth, clientWidth } = carouselRef.current;

    if (marginsRef?.current) {
      marginWidth = marginsRef.current.clientWidth;
    }

    const value = {
      from: 0,
      to: scrollWidth <= clientWidth ? 0 : `-${scrollWidth - (clientWidth - marginWidth)}`,
    };

    const positions = carouselItemsRef?.current?.map((item: HTMLElement) => ({
      item,
      left: item?.offsetLeft || 0,
      right: (item?.offsetLeft || 0) + (item?.offsetWidth || 0),
    }));

    const distance = -(imageScale - 1) * 100;

    const updateImageParallax = () => {
      if (imageScale > 1) {
        positions?.forEach((position, index) => {
          const inView =
            position.right > Math.abs(value.from) &&
            position.left - Math.abs(value.from) < clientWidth;

          if (inView && imagesRef?.current) {
            const width = position.right - position.left;
            const total = position.left + width;
            const currentPosition = Math.abs(value.from);
            const progress = currentPosition / total;
            setImageX[index](distance / 2 + -distance * progress);
            // gsap.set(imagesRef?.current[index], { xPercent: distance / 2 + -distance * progress });
          }
        });
      }
    };

    if (imageScale > 1) {
      imagesRef?.current?.forEach((image) => {
        gsap.set(image, { scale: imageScale });
      });
    }

    updateImageParallax();

    timeline.to(value, {
      from: value.to,
      onUpdate: () => {
        updateImageParallax();
        setCarouselX(value.from);
      },
      ease: 'none',
    });
  }
}
